import { useParams } from 'react-router'
import { useUnsubscribeEmailMutation } from '../../features/SpeechAgendaApiSlice.ts'
import GenericErrorPage from '../GenericErrorPage.tsx'

// No token→email lookup by design: generic copy avoids leaking who the token
// belongs to.
export default function Unsubscribe() {
  const { token } = useParams<{ token: string }>()
  const [unsubscribeEmail, { isLoading, isSuccess, isError }] =
    useUnsubscribeEmailMutation()

  if (!token || isError) {
    return (
      <GenericErrorPage
        title="Unsubscribe link is invalid"
        description="This unsubscribe link is invalid or has expired. If you keep receiving emails you'd rather not get, please reach out and we'll help.">
        <a
          href="mailto:support@speechagenda.com?subject=Unsubscribe%20help"
          className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
          Contact support
        </a>
      </GenericErrorPage>
    )
  }

  return (
    <main className="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8 custom-max-w-920px m-auto">
      <div className="max-w-md text-center">
        {isSuccess ? (
          <>
            <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">
              You've been unsubscribed
            </h1>
            <p className="mt-6 text-base leading-7 text-gray-600">
              You won't receive Speech Agenda meeting emails anymore. Changed
              your mind? You can opt back in from your club's settings.
            </p>
          </>
        ) : (
          <>
            <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">
              Unsubscribe from Speech Agenda meeting emails?
            </h1>
            <p className="mt-6 text-base leading-7 text-gray-600">
              You'll stop receiving meeting digest emails from Speech Agenda.
            </p>
            <div className="mt-10 flex items-center justify-center gap-x-6">
              <button
                type="button"
                disabled={isLoading}
                onClick={() => unsubscribeEmail(token)}
                className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:cursor-not-allowed disabled:opacity-60">
                {isLoading ? 'Unsubscribing…' : 'Unsubscribe'}
              </button>
            </div>
          </>
        )}
      </div>
    </main>
  )
}
